var _style, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsflag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 551.68 320.13",
    style: {
      enableBackground: "new 0 0 551.68 320.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B21F34;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#243B6F;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "518.62,29.14 27,29.16 27,295.84 518.62,295.89 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.32,
    y: 49.68,
    className: "st1",
    width: 290.3,
    height: 20.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228.32,
    y: 90.73,
    className: "st1",
    width: 290.3,
    height: 20.54
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 228.32,
    y: 131.8,
    className: "st1",
    width: 290.3,
    height: 20.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 213.92,
    className: "st1",
    width: 491.63,
    height: 20.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.99,
    y: 254.97,
    className: "st1",
    width: 491.63,
    height: 20.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29.16,
    className: "st2",
    width: 201.64,
    height: 143.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.86,40.62 46.25,40.62 44.49,35.42 42.79,40.62 37.09,40.62 41.67,43.96 39.76,49.47 44.51,46.03  49.12,49.43 47.28,43.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.64,155.82 46.04,155.82 44.28,150.62 42.57,155.82 36.88,155.82 41.46,159.15 39.55,164.68  44.3,161.23 48.91,164.63 47.07,159.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.86,69.75 46.25,69.75 44.49,64.56 42.79,69.75 37.09,69.75 41.67,73.1 39.76,78.61 44.51,75.17  49.12,78.57 47.28,73.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.64,98.11 46.04,98.11 44.28,92.91 42.57,98.11 36.88,98.11 41.46,101.45 39.55,106.97 44.3,103.52  48.91,106.93 47.07,101.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.86,127.07 46.25,127.07 44.49,121.86 42.79,127.07 37.09,127.07 41.67,130.41 39.76,135.93  44.51,132.48 49.12,135.88 47.28,130.43  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.25,41.05 79.64,41.05 77.88,35.84 76.18,41.05 70.48,41.05 75.06,44.39 73.16,49.9 77.9,46.46  82.51,49.85 80.68,44.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.04,156.25 79.43,156.25 77.66,151.05 75.96,156.25 70.27,156.25 74.85,159.58 72.94,165.11  77.69,161.66 82.3,165.06 80.46,159.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.25,70.17 79.64,70.17 77.88,64.98 76.18,70.17 70.48,70.17 75.06,73.52 73.16,79.04 77.9,75.59  82.51,78.99 80.68,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.04,98.53 79.43,98.53 77.66,93.34 75.96,98.53 70.27,98.53 74.85,101.87 72.94,107.4  77.69,103.95 82.3,107.36 80.46,101.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "85.25,127.5 79.64,127.5 77.88,122.29 76.18,127.5 70.48,127.5 75.06,130.83 73.16,136.35  77.9,132.91 82.51,136.31 80.68,130.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "119.07,41.05 113.46,41.05 111.7,35.84 110,41.05 104.3,41.05 108.88,44.39 106.98,49.9  111.72,46.46 116.33,49.85 114.49,44.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.86,156.25 113.25,156.25 111.48,151.05 109.78,156.25 104.09,156.25 108.67,159.58  106.76,165.11 111.51,161.66 116.12,165.06 114.28,159.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "119.07,70.17 113.46,70.17 111.7,64.98 110,70.17 104.3,70.17 108.88,73.52 106.98,79.04  111.72,75.59 116.33,78.99 114.49,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "118.86,98.53 113.25,98.53 111.48,93.34 109.78,98.53 104.09,98.53 108.67,101.87 106.76,107.4  111.51,103.95 116.12,107.36 114.28,101.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "119.07,127.5 113.46,127.5 111.7,122.29 110,127.5 104.3,127.5 108.88,130.83 106.98,136.35  111.72,132.91 116.33,136.31 114.49,130.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.89,41.05 147.28,41.05 145.52,35.84 143.82,41.05 138.12,41.05 142.7,44.39 140.79,49.9  145.54,46.46 150.15,49.85 148.31,44.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.68,156.25 147.06,156.25 145.3,151.05 143.6,156.25 137.91,156.25 142.48,159.58 140.58,165.11  145.32,161.66 149.94,165.06 148.1,159.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.89,70.17 147.28,70.17 145.52,64.98 143.82,70.17 138.12,70.17 142.7,73.52 140.79,79.04  145.54,75.59 150.15,78.99 148.31,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.68,98.53 147.06,98.53 145.3,93.34 143.6,98.53 137.91,98.53 142.48,101.87 140.58,107.4  145.32,103.95 149.94,107.36 148.1,101.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.89,127.5 147.28,127.5 145.52,122.29 143.82,127.5 138.12,127.5 142.7,130.83 140.79,136.35  145.54,132.91 150.15,136.31 148.31,130.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.28,41.05 180.67,41.05 178.91,35.84 177.21,41.05 171.51,41.05 176.09,44.39 174.18,49.9  178.93,46.46 183.54,49.85 181.7,44.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.07,156.25 180.46,156.25 178.7,151.05 177,156.25 171.3,156.25 175.88,159.58 173.97,165.11  178.72,161.66 183.33,165.06 181.49,159.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.28,70.17 180.67,70.17 178.91,64.98 177.21,70.17 171.51,70.17 176.09,73.52 174.18,79.04  178.93,75.59 183.54,78.99 181.7,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.07,98.53 180.46,98.53 178.7,93.34 177,98.53 171.3,98.53 175.88,101.87 173.97,107.4  178.72,103.95 183.33,107.36 181.49,101.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.28,127.5 180.67,127.5 178.91,122.29 177.21,127.5 171.51,127.5 176.09,130.83 174.18,136.35  178.93,132.91 183.54,136.31 181.7,130.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.67,40.84 214.06,40.84 212.3,35.63 210.6,40.84 204.91,40.84 209.48,44.18 207.58,49.68  212.33,46.25 216.94,49.64 215.1,44.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.46,156.04 213.85,156.04 212.09,150.84 210.39,156.04 204.69,156.04 209.27,159.37  207.36,164.89 212.11,161.44 216.72,164.85 214.88,159.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.67,69.97 214.06,69.97 212.3,64.78 210.6,69.97 204.91,69.97 209.48,73.31 207.58,78.82  212.33,75.38 216.94,78.78 215.1,73.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.46,98.33 213.85,98.33 212.09,93.12 210.39,98.33 204.69,98.33 209.27,101.66 207.36,107.19  212.11,103.74 216.72,107.15 214.88,101.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "219.67,127.29 214.06,127.29 212.3,122.08 210.6,127.29 204.91,127.29 209.48,130.62 207.58,136.14  212.33,132.7 216.94,136.1 215.1,130.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.54,55.16 62.93,55.16 61.17,49.95 59.47,55.16 53.78,55.16 58.35,58.49 56.45,64 61.19,60.57  65.81,63.96 63.96,58.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.54,84.28 62.93,84.28 61.17,79.09 59.47,84.28 53.78,84.28 58.35,87.63 56.45,93.14 61.19,89.7  65.81,93.1 63.96,87.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.33,112.64 62.72,112.64 60.96,107.44 59.26,112.64 53.56,112.64 58.14,115.98 56.23,121.51  60.98,118.06 65.59,121.47 63.75,115.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.54,141.61 62.93,141.61 61.17,136.39 59.47,141.61 53.78,141.61 58.35,144.94 56.45,150.46  61.19,147.02 65.81,150.42 63.96,144.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.36,55.16 96.75,55.16 94.99,49.95 93.29,55.16 87.6,55.16 92.17,58.49 90.26,64 95.01,60.57  99.62,63.96 97.78,58.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.36,84.28 96.75,84.28 94.99,79.09 93.29,84.28 87.6,84.28 92.17,87.63 90.26,93.14 95.01,89.7  99.62,93.1 97.78,87.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.15,112.64 96.54,112.64 94.77,107.44 93.08,112.64 87.38,112.64 91.96,115.98 90.05,121.51  94.8,118.06 99.41,121.47 97.57,115.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.36,141.61 96.75,141.61 94.99,136.39 93.29,141.61 87.6,141.61 92.17,144.94 90.26,150.46  95.01,147.02 99.62,150.42 97.78,144.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.18,55.16 130.57,55.16 128.81,49.95 127.11,55.16 121.41,55.16 125.99,58.49 124.08,64  128.83,60.57 133.44,63.96 131.6,58.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.18,84.28 130.57,84.28 128.81,79.09 127.11,84.28 121.41,84.28 125.99,87.63 124.08,93.14  128.83,89.7 133.44,93.1 131.6,87.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "135.97,112.64 130.36,112.64 128.59,107.44 126.9,112.64 121.2,112.64 125.78,115.98 123.87,121.51  128.62,118.06 133.23,121.47 131.39,115.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.18,141.61 130.57,141.61 128.81,136.39 127.11,141.61 121.41,141.61 125.99,144.94  124.08,150.46 128.83,147.02 133.44,150.42 131.6,144.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170,55.16 164.39,55.16 162.62,49.95 160.93,55.16 155.23,55.16 159.81,58.49 157.9,64 162.65,60.57  167.26,63.96 165.42,58.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170,84.28 164.39,84.28 162.62,79.09 160.93,84.28 155.23,84.28 159.81,87.63 157.9,93.14  162.65,89.7 167.26,93.1 165.42,87.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "169.79,112.64 164.18,112.64 162.41,107.44 160.71,112.64 155.02,112.64 159.6,115.98 157.69,121.51  162.44,118.06 167.05,121.47 165.21,115.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170,141.61 164.39,141.61 162.62,136.39 160.93,141.61 155.23,141.61 159.81,144.94 157.9,150.46  162.65,147.02 167.26,150.42 165.42,144.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "203.18,55.16 197.57,55.16 195.81,49.95 194.11,55.16 188.41,55.16 192.99,58.49 191.08,64  195.83,60.57 200.44,63.96 198.6,58.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "203.18,84.28 197.57,84.28 195.81,79.09 194.11,84.28 188.41,84.28 192.99,87.63 191.08,93.14  195.83,89.7 200.44,93.1 198.6,87.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "202.96,112.64 197.35,112.64 195.59,107.44 193.89,112.64 188.2,112.64 192.77,115.98 190.87,121.51  195.61,118.06 200.22,121.47 198.39,115.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "203.18,141.61 197.57,141.61 195.81,136.39 194.11,141.61 188.41,141.61 192.99,144.94  191.08,150.46 195.83,147.02 200.44,150.42 198.6,144.97  "
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 172.86,
    className: "st1",
    width: 491.69,
    height: 20.52
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsflag);
export default __webpack_public_path__ + "static/media/usflag.6a27775024c059b22d12ff301e6b673b.svg";
export { ForwardRef as ReactComponent };